import { links } from "./links";

const appStartParams = [
  "repeat_all",
  "catalog",
  "pro",
  "settings",
  "ui_kit",
] as const;

type AppStartParam = (typeof appStartParams)[number];

export function isAppStartParam(value: string): value is AppStartParam {
  return appStartParams.some((param) => param === value);
}

export function getTelegramAppStartLink(startParam: AppStartParam) {
  return `${links.botApp}?startapp=${startParam}`;
}
